type Props = {
  label: string;

  type: string;
  name: string;
  required?: boolean;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

export const Input = ({
  label,
  type,
  name,
  required = false,
  value,
  onChange,
}: Props) => {
  return (
    <div className="flex flex-col gap-y-2">
      <label htmlFor={name} className="font-bold text-white">
        {label}
      </label>
      <input
        type={type}
        name={name}
        required={required}
        value={value}
        onChange={onChange}
        className="py-3 px-4 bg-transparent border border-gray-700 rounded-[7px] text-white"
      />
    </div>
  );
};
